import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpUnmetDemandKeys = {
  all: ['analytics', 'fp-unmet-demand'] as const,
  list: (params?: AnalyticsQueryParams) => [...fpUnmetDemandKeys.all, 'list', params] as const,
};

export const useFPUnmetDemandData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpUnmetDemandKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPUnmetDemand(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
